/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */

import { customElement } from 'common';

import K12HallpassStudentrestrictions from './components/k12-hallpass-studentrestrictions/k12-hallpass-studentrestrictions';
export * from './components/k12-hallpass-studentrestrictions/k12-hallpass-studentrestrictions';
export { K12HallpassStudentrestrictions };
customElement.register('k12-hallpass-studentrestrictions', 'sis', K12HallpassStudentrestrictions.defaultProps, K12HallpassStudentrestrictions);

import K12HallpassStuhallpasses from './components/k12-hallpass-stuhallpasses/k12-hallpass-stuhallpasses';
export * from './components/k12-hallpass-stuhallpasses/k12-hallpass-stuhallpasses';
export { K12HallpassStuhallpasses };
customElement.register('k12-hallpass-stuhallpasses', 'sis', K12HallpassStuhallpasses.defaultProps, K12HallpassStuhallpasses);

import K12HallpassStuhallpasssummary from './components/k12-hallpass-stuhallpasssummary/k12-hallpass-stuhallpasssummary';
export * from './components/k12-hallpass-stuhallpasssummary/k12-hallpass-stuhallpasssummary';
export { K12HallpassStuhallpasssummary };
customElement.register('k12-hallpass-stuhallpasssummary', 'sis', K12HallpassStuhallpasssummary.defaultProps, K12HallpassStuhallpasssummary);

import K12IncidentSummary from './components/k12-incident-summary/k12-incident-summary';
export * from './components/k12-incident-summary/k12-incident-summary';
export { K12IncidentSummary };
customElement.register('k12-incident-summary', 'sis', K12IncidentSummary.defaultProps, K12IncidentSummary);

import Index from './components/sis-index/sis-index';
export * from './components/sis-index/sis-index';
export { Index };
customElement.register('sis-index', 'sis', Index.defaultProps, Index);

import K12GradReqOverviewDetailHeader from './components/sis-k12-grad-req-overview-detail-header/sis-k12-grad-req-overview-detail-header';
export * from './components/sis-k12-grad-req-overview-detail-header/sis-k12-grad-req-overview-detail-header';
export { K12GradReqOverviewDetailHeader };
customElement.register('sis-k12-grad-req-overview-detail-header', 'sis', K12GradReqOverviewDetailHeader.defaultProps, K12GradReqOverviewDetailHeader);

import K12GradreqGradeLayout from './components/sis-k12-gradreq-grade-layout/sis-k12-gradreq-grade-layout';
export * from './components/sis-k12-gradreq-grade-layout/sis-k12-gradreq-grade-layout';
export { K12GradreqGradeLayout };
customElement.register('sis-k12-gradreq-grade-layout', 'sis', K12GradreqGradeLayout.defaultProps, K12GradreqGradeLayout);

import K12GradreqThreshold from './components/sis-k12-gradreq-threshold/sis-k12-gradreq-threshold';
export * from './components/sis-k12-gradreq-threshold/sis-k12-gradreq-threshold';
export { K12GradreqThreshold };
customElement.register('sis-k12-gradreq-threshold', 'sis', K12GradreqThreshold.defaultProps, K12GradreqThreshold);

import K12NewyearinfoSetupWizardProgressBar from './components/sis-k12-newyearinfo-setup-wizard-progress-bar/sis-k12-newyearinfo-setup-wizard-progress-bar';
export * from './components/sis-k12-newyearinfo-setup-wizard-progress-bar/sis-k12-newyearinfo-setup-wizard-progress-bar';
export { K12NewyearinfoSetupWizardProgressBar };
customElement.register('sis-k12-newyearinfo-setup-wizard-progress-bar', 'sis', K12NewyearinfoSetupWizardProgressBar.defaultProps, K12NewyearinfoSetupWizardProgressBar);

import MobileConfigurationViewer from './components/sis-mobile-configuration-viewer/sis-mobile-configuration-viewer';
export * from './components/sis-mobile-configuration-viewer/sis-mobile-configuration-viewer';
export { MobileConfigurationViewer };
customElement.register('sis-mobile-configuration-viewer', 'sis', MobileConfigurationViewer.defaultProps, MobileConfigurationViewer);

import NyrsetupDefinitiontiles from './components/sis-nyrsetup-definitiontiles/sis-nyrsetup-definitiontiles';
export * from './components/sis-nyrsetup-definitiontiles/sis-nyrsetup-definitiontiles';
export { NyrsetupDefinitiontiles };
customElement.register('sis-nyrsetup-definitiontiles', 'sis', NyrsetupDefinitiontiles.defaultProps, NyrsetupDefinitiontiles);

import ParentSelect from './components/sis-parent-select/sis-parent-select';
export * from './components/sis-parent-select/sis-parent-select';
export { ParentSelect };
customElement.register('sis-parent-select', 'sis', ParentSelect.defaultProps, ParentSelect);

import RoleDashboard from './components/sis-role-dashboard/sis-role-dashboard';
export * from './components/sis-role-dashboard/sis-role-dashboard';
export { RoleDashboard };
customElement.register('sis-role-dashboard', 'sis', RoleDashboard.defaultProps, RoleDashboard);

import StudentSelect from './components/sis-student-select/sis-student-select';
export * from './components/sis-student-select/sis-student-select';
export { StudentSelect };
customElement.register('sis-student-select', 'sis', StudentSelect.defaultProps, StudentSelect);

import TwoPointSlider from './components/sis-two-point-slider/sis-two-point-slider';
export * from './components/sis-two-point-slider/sis-two-point-slider';
export { TwoPointSlider };
customElement.register('sis-two-point-slider', 'sis', TwoPointSlider.defaultProps, TwoPointSlider);

